import React, { useState, useEffect } from 'react';
import api from '../api/axios';
import { useAuth } from '../context/AuthContext';

const Notifications = () => {
  const { role } = useAuth();
  const isAdmin = role === 'ADMIN' || role === 'SUPER_ADMIN';
  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');
  const [broadcasts, setBroadcasts] = useState([]);

  useEffect(() => {
    // The broadcast HISTORY endpoint is admin-only. A vendor or centre gets
    // their own feed elsewhere on this page — asking anyway just filled
    // their console with the guard's 403s.
    if (isAdmin) fetchBroadcasts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAdmin]);

  const fetchBroadcasts = async () => {
    try {
      const res = await api.get('/notifications/broadcasts');
      if (res.data.success) {
        setBroadcasts(res.data.data);
      }
    } catch (error) {
      if (error?.response?.status !== 403) console.error('Failed to fetch history:', error);
    }
  };

  const handleSendBroadcast = async (e) => {
    e.preventDefault();
    if(!title || !message) {
        alert("Title and Message are required!");
        return;
    }
    
    try {
      const res = await api.post('/notifications/broadcast', { title, body: message });
      if (res.data.success) {
        alert(`📢 Global Broadcast Sent: ${title}`);
        setTitle('');
        setMessage('');
        // Add new broadcast to the top of history list instantly
        setBroadcasts(prev => [res.data.data, ...prev]);
      }
    } catch (error) {
      console.error("Broadcast failed:", error);
      alert("❌ Failed to send broadcast. Check backend logs.");
    }
  };

  return (
    <div className="p-8">
      <div className="mb-8">
        <h2 className="font-serif text-3xl font-bold text-[#2A2858]">Divine Broadcasts</h2>
        <p className="mt-1 text-stone-500 text-sm">Send real-time alerts and event updates to all devotees</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* Broadcast Form */}
        <div className="glass-card p-6 border-t-4 border-t-[#E8B84B]">
          <h3 className="font-bold text-lg text-[#2A2858] mb-4 flex items-center gap-2">
            <span className="material-symbols-outlined">campaign</span> New Broadcast
          </h3>
          <form onSubmit={handleSendBroadcast} className="space-y-4">
            <div>
              <label className="block text-xs font-bold text-stone-500 uppercase mb-1">Alert Title</label>
              <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} placeholder="e.g. Maha Aarti Starting Now!" className="w-full border border-stone-200 rounded-lg px-4 py-2.5 text-sm focus:border-[#E8B84B] outline-none" />
            </div>
            <div>
              <label className="block text-xs font-bold text-stone-500 uppercase mb-1">Message</label>
              <textarea value={message} onChange={(e) => setMessage(e.target.value)} rows="4" placeholder="Type your divine message here..." className="w-full border border-stone-200 rounded-lg px-4 py-2.5 text-sm focus:border-[#E8B84B] outline-none"></textarea>
            </div>
            <button type="submit" className="w-full btn-primary py-3 rounded-lg flex justify-center items-center gap-2">
              <span className="material-symbols-outlined">send</span> Send Notification
            </button>
          </form>
        </div>

        {/* Broadcast History */}
        <div className="bg-white border border-[#E8B84B]/20 rounded-2xl overflow-hidden shadow-sm">
          <div className="bg-[#FAF9F6] border-b border-[#E8B84B]/20 px-6 py-4">
            <h3 className="font-bold text-stone-800 text-sm uppercase tracking-widest">Recent Broadcasts</h3>
          </div>
          <div className="divide-y divide-stone-50 max-h-[600px] overflow-y-auto">
            {broadcasts.length === 0 ? (
              <div className="p-8 text-center text-stone-400 italic text-sm">
                No history available.
              </div>
            ) : (
              broadcasts.map((b) => (
                <div key={b._id} className="p-6 hover:bg-stone-50 transition-colors">
                  <div className="flex justify-between items-start mb-1">
                    <h4 className="font-bold text-stone-800">{b.title}</h4>
                    <span className="text-[10px] font-bold text-stone-400 uppercase tracking-tighter">
                      {new Date(b.createdAt).toLocaleDateString()}
                    </span>
                  </div>
                  <p className="text-sm text-stone-500 leading-relaxed">{b.body}</p>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Notifications;